/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconPercentage66 = createReactComponent("outline", "percentage-66", "IconPercentage66", [["path", { "d": "M12 3a9 9 0 1 1 -7.795 13.498l7.795 -4.498z", "fill": "currentColor", "stroke": "none", "key": "svg-0" }], ["path", { "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0", "key": "svg-1" }]]);

export { IconPercentage66 as default };
//# sourceMappingURL=IconPercentage66.mjs.map
